module.exports = __webpack_public_path__ + "static/media/vinos_rosados.3c5ffcc8.jpg";